import { render, staticRenderFns } from "./HelperClassComponent.vue?vue&type=template&id=315a8634&"
import script from "./HelperClassComponent.vue?vue&type=script&lang=js&"
export * from "./HelperClassComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports